import React, { useState } from 'react'
import DashboardBars from '../components/DashboardBars'
import DashboardHeader from '../components/DashboardHeader'
import InnerPage from '../components/InnerPage'

const Layout = () => {

  const [accountPage, setAccountPage] = useState(true)
  const [transactionPage, setTransacrionPage] = useState(false)

  const [userID, setUserID] = useState('169878')

    function toggleTransacrionPage() { 
        setTransacrionPage(true)
        setAccountPage(false)
    }

    function toggleAccountPage () { 
        setAccountPage(true)
        setTransacrionPage(false)
    }

  return (
    <div>
        <DashboardBars      
          userID={userID}   
          toggleAccountPage={toggleAccountPage} 
          toggleTransacrionPage={toggleTransacrionPage}
          accountPage={accountPage} 
          transactionPage={transactionPage}
        />
        <div className="dashboard__body">
          <DashboardHeader 
            userID={userID}   
          />

          <div className="dashboard__account">
            <InnerPage 
              accountPage={accountPage} 
              transactionPage={transactionPage}
            />
          </div>

        </div>
    </div>
  )
}

export default Layout